import * as utils from "../utils/utils.js";

export default function () {
  const widgetName = "fairGridGalleryLarge";
  const widgetOpts = fairGridGalleryLargeOpts;
  const $widget = $(`#${widgetName}`);

  const linkedImages = true;

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ["all"] : [""],
    hasImages: true,
    textOverImage: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    maxItemsVisible: 12,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $widget.remove();
      } else {
        changeFormatCards(data.items);
      }
    },
  });

  function changeFormatCards(widgetData) {
    $widget.find(".card-content").remove();
    $widget.find(".card-widget-item").each(function (x) {
      const { URL } = widgetData[x];
      const $card = $(this);

      if (!URL) {
        $card.removeAttr("href");
      }

      if (linkedImages) {
        $card.addClass("linked-images");
      }
      if (utils.isLocalUrl(URL)) {
        $card.removeAttr("target");
      }
    });
  }
}
